var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInboxOnHover({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e0LSuzDtJAp1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 46 42",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    width: 46,
    height: 42,
    style: {
      backgroundColor: "transparent"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 42,
    rx: 0,
    ry: 0,
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.5,5.5h23c2.2,0,4,1.8,4,4v23c0,2.2-1.8,4-4,4h-23c-2.2,0-4-1.8-4-4v-23c0-2.2,1.8-4,4-4Z",
    fill: "#597893"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.6,30.1h14.8c.9,0,1.6-.6,1.6-1.4v-12.1c0-.8-.7-1.3-1.6-1.3h-3.3v1.1h3.3c.2,0,.3.1.3.2v12.1c0,.1-.1.2-.3.2h-14.8c-.2,0-.3-.1-.3-.2v-12.1c0-.1.1-.2.3-.2h3.1v-1.2h-3.1c-.9,0-1.6.6-1.6,1.3v12.1c0,.9.7,1.5,1.6,1.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8,25.9h-4.4v.4h4.4v-.4Zm0,1.5h-4.4v.4h4.4v-.4Zm-3.1-.7h-1.2v.4h1.2v-.4v0Zm1.8,0h-1.2v.4h1.2v-.4Zm-8.7-8.6l3.7,3.1c.3.2.6.2.9,0l3.7-3.1c.4-.3.1-.9-.5-.9h-1.4v-5.3h-4.7v5.3h-1.5c-.3,0-.6.6-.2.9v0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,2h.8c1.7,0,3,1.4,3,3v32c0,1.7-1.4,3-3,3h-.8L0,2Z",
    fill: "#597893"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxOnHover);
export default __webpack_public_path__ + "static/media/InboxOnHover.0cd0874875f456c58606ebcb104e56ec.svg";
export { ForwardRef as ReactComponent };